export default `float i,a,n,h,d=1.,t=0.3; 
    vec3 q;
    n=.4;
    for(a=1.;a<2e2;n+=q.x*q.y*q.z/a)
      p.xy*=rotate2D(a+=a),
      q=cos(p*a+t);
    return n*.3;
  }`